var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewMenuButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(-1773 -18)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_606",
    "data-name": "Ellipse 606",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(1773 18)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(1793.437 46.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M38.158,13.052H5.963A1.468,1.468,0,0,1,4.5,11.588h0a1.468,1.468,0,0,1,1.463-1.463H38.158a1.468,1.468,0,0,1,1.463,1.463h0A1.468,1.468,0,0,1,38.158,13.052Z",
    transform: "translate(-4.5 -10.124)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M38.158,19.8H5.963A1.468,1.468,0,0,1,4.5,18.338h0a1.468,1.468,0,0,1,1.463-1.463H38.158a1.468,1.468,0,0,1,1.463,1.463h0A1.468,1.468,0,0,1,38.158,19.8Z",
    transform: "translate(-4.5 -8.094)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M38.158,26.552H5.963A1.468,1.468,0,0,1,4.5,25.088h0a1.468,1.468,0,0,1,1.463-1.463H38.158a1.468,1.468,0,0,1,1.463,1.463h0A1.468,1.468,0,0,1,38.158,26.552Z",
    transform: "translate(-4.5 -6.064)",
    fill: "#1a1a1a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuButton);
export default __webpack_public_path__ + "static/media/newMenuButton.15fb605fbddb534b8ea7a507f5300048.svg";
export { ForwardRef as ReactComponent };